import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProgramList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/programs', {
            params: queryParams,
          })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
  },
}
